import { render, staticRenderFns } from "./EstimatesAdditionalPage.vue?vue&type=template&id=c496689c&"
import script from "./EstimatesAdditionalPage.vue?vue&type=script&lang=ts&"
export * from "./EstimatesAdditionalPage.vue?vue&type=script&lang=ts&"
import style0 from "./EstimatesAdditionalPage.vue?vue&type=style&index=0&id=c496689c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports